import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Atmosphere from "@/components/Atmosphere";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Home from "@/pages/Home";
import DailyLog from "@/pages/DailyLog";
import Dashboard from "@/pages/Dashboard";
import Correlations from "@/pages/Correlations";
import Calendar from "@/pages/Calendar";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <Atmosphere />
      <div className="relative z-10">
        <BrowserRouter>
          <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Home />} />
              <Route path="/log" element={<DailyLog />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/correlations" element={<Correlations />} />
              <Route path="/calendario" element={<Calendar />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
